console.log('filter.js script loaded');

document.addEventListener("DOMContentLoaded", function () {
    console.log('DOMContentLoaded fired in filter.js');
    
    // Check if we're on a page with job listings
    const jobCards = document.querySelectorAll('.job-card');
    
    // Always update job count, even if no job cards exist
    updateJobCount();
    
    if (jobCards.length === 0) {
        console.log('No job cards found, skipping filter initialization');
        return;
    }
    
    // Initial filter run
    filterJobs();

    // Debug: Check if filter elements exist
    console.log('Checking for filter elements...');
    console.log('filter-county exists:', !!document.getElementById("filter-county"));
    console.log('All elements with "filter" in ID:', document.querySelectorAll('[id*="filter"]').length);

    // Filter Change
    const filterSelects = document.querySelectorAll('#filter-time, #filter-education, #filter-county');
    
    filterSelects.forEach((el, index) => {
        if (el) {
            // Use onchange instead of addEventListener
            el.onchange = function(e) {
                filterJobs();
            };
        }
    });
    
    // Clear Filter Link
    const filterClearElement = document.getElementById("filter-clear");
    if (filterClearElement) {
        filterClearElement.addEventListener("click", e => {
            e.preventDefault();
            const filterTime = document.getElementById("filter-time");
            const filterCounty = document.getElementById("filter-county");
            const filterEducation = document.getElementById("filter-education");
            
            if (filterTime) filterTime.value = "all-time";
            if (filterCounty) filterCounty.value = "all-counties";
            if (filterEducation) filterEducation.value = "all-education";
            
            filterJobs();
        });
    }
});

function filterJobs () {
    const filterTime = document.getElementById("filter-time");
    const filterCounty = document.getElementById("filter-county");
    const filterEducation = document.getElementById("filter-education");

    // If any filter element is missing, skip filtering but still update count
    if (!filterTime || !filterCounty || !filterEducation) {
        updateJobCount();
        return;
    }

    const selectedTime = filterTime.value;
    const selectedCounty = filterCounty.value;
    const selectedEducation = filterEducation.value;
    
    document.querySelectorAll(".job-card").forEach((card, index) => {
        const timeValue = card.dataset.time;
        const countyValue = card.dataset.county;
        const educationValue = card.dataset.educationValue;  // 0, 1, 2, 3, 4

        let timeMatch = selectedTime === "all-time" || timeValue === selectedTime;
        let countyMatch = selectedCounty === "all-counties" || countyValue === selectedCounty;
        let educationMatch = selectedEducation === "all-education" || educationValue === selectedEducation;

        const isVisible = timeMatch && countyMatch && educationMatch;

        card.style.display = isVisible ? "flex" : "none";
    });

    const visibleCards = Array.from(document.querySelectorAll(".job-card"))
        .filter(card => card.style.display !== "none");

    visibleCards.forEach((card, index) => {
        card.classList.remove("even", "odd");
        card.classList.add(index % 2 === 0 ? "odd" : "even");
    });

    // Update job count display
    updateJobCount();
}

// Separate function for updating job count
function updateJobCount() {
    const jobCountElements = document.querySelectorAll(".job-count");
    if (jobCountElements.length) {
        const allJobCards = document.querySelectorAll(".job-card");
        const visibleCards = Array.from(allJobCards)
            .filter(card => card.style.display !== "none");
        const visibleCount = visibleCards.length;
        
        // Debug logging
        console.log('updateJobCount - All job cards:', allJobCards.length);
        console.log('updateJobCount - Visible job cards:', visibleCount);
        console.log('updateJobCount - Job count elements:', jobCountElements.length);
        
        // Always show a number, even if it's 0
        const jobText = visibleCount === 1 ? "job&nbsp;" : "jobs&nbsp;";
        jobCountElements.forEach(jobCountElement => {
            jobCountElement.innerHTML = `${visibleCount} ${jobText}`;
        });
        
        console.log('updateJobCount - Updated HTML:', `${visibleCount} ${jobText}`);
    } else {
        console.log('updateJobCount - Job count element not found');
    }
}

window.filterJobs = filterJobs;


